import React, { Dispatch, SetStateAction, useEffect, useState } from "react"

import { Provider } from "@lib/types/generated/graphql-types"
import { PROVIDER_TYPE } from "lib/types/common"

import { PushUrl } from "./QliroOneConfigTable.styled"
import { Container, Wrapper, IconTableHeader, EmptyList } from "components/Ui/Table/Shared.styled"

import ErrorMessage from "../../Ui/Messages/ErrorMessage"
import { QliroOneConfigTableRow } from "./QliroOneConfigTableRow"
import TableBlurLoading from "../../Ui/Table/TableBlurLoading"
import { getLoadingRow } from "./QliroOneConfigTableRow"

type Props = {
  providers: Provider[]
  error: object | undefined
  setEditId?: Dispatch<SetStateAction<string>>
  loading: boolean
}

export const QliroOneConfigTable = ({ providers, setEditId, error, loading }: Props) => {
  const [qliroOneProviders, setQliroOneProviders] = useState<Provider[]>([])

  useEffect(() => {
    if (providers) {
      setQliroOneProviders(
        providers?.filter((provider) => provider.type === PROVIDER_TYPE.QLIRO_ONE)
      )
    }
  }, [providers])

  const tableHeader = (
    <IconTableHeader>
      <div>Identifier</div>
      <div>Environment</div>
      <PushUrl className="hideOnSmallScreens">Order management status push URL:</PushUrl>
      <div className="hideOnSmallScreens">Created</div>
      <div className="hideOnSmallScreens">Updated</div>
    </IconTableHeader>
  )

  if (loading)
    return <TableBlurLoading numberOfRows={2} tableHeader={tableHeader} rows={getLoadingRow()} />

  if (qliroOneProviders?.length < 1)
    return (
      <EmptyList>
        <p> No configurations added</p>
      </EmptyList>
    )
  if (!providers) return null

  return (
    <Wrapper>
      <Container>
        {error && (
          <ErrorMessage
            showRefreshButton
            message={
              <>
                Error loading Qliro One configurations. Try refreshing the page, or contact{" "}
                <a href="mailto:support@brinkcommerce.com">support</a>.
              </>
            }
          />
        )}
        {tableHeader}
        {[...qliroOneProviders].map((qliroOneProvider) => (
          <QliroOneConfigTableRow
            key={qliroOneProvider.id}
            id={qliroOneProvider.id}
            setEditId={setEditId}
          />
        ))}
      </Container>
    </Wrapper>
  )
}
